module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CNCT",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_vm._v("1 The Ax")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara"
  }, [_vm._v("Out of the air, the ax. Somehow there was an ax and it rose and fell in a wild swath aimed at my head even as I tried to rise from my squatting position and lost my balance desperate to escape as my legs faltered beneath me and there came a hoarse pleading voice—“No! No please! No”—(was this my own choked voice, unrecognizable?)—as the ax-blade crashed and sank into the splintering desk beside my head missing my head by inches; by which time I’d fallen heavily onto the floor, a hard unyielding floor beneath the frayed Oriental carpet. I was scrambling to right myself, grabbing for the ax, desperate to seize the ax, in the blindness of desperation my hands flailing, and the voice (my own? my assailant’s?) high-pitched and hardly human-sounding—“No! "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Nooo")]), _vm._v("”—a fleeting glimpse of the assailant’s stubby fingers and dead-white ropey-muscled arms inside the flimsy sleeves of nightwear, and a grunting cry as of triumph and fury commingled; and again the terrible lifting of the ax-head, the dull sheen of the crude ax-blade, and the downward swing of Death once begun unstoppable, irretrievable plunging into a human skull as easily rent as a melon with no more protection than a thick rind, to expose the pulpy gray-matter of the brain amid a torrential gushing of arterial blood.")]), _vm._v(" "), _c('p', {
    staticClass: "BT"
  }, [_vm._v("And still the voice rising disbelieving "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("No no no no no.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683b3a1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook43527.vue
// module id = 84
// module chunks = 0